import config from '../config'; // Adjust the path as necessary
import PropTypes from 'prop-types';

const FeatureEnabled = ({ feature, children }) => {
  const featureConfig = config.FEATURE_FLAGS[feature];

  return featureConfig?.enabled ? children : null;
};

FeatureEnabled.propTypes = {
  feature: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default FeatureEnabled;